/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export interface IStorage {
   getItem(inKey: string): any;
   setItem(inKey: string, value: any): void;
   removeItem(inKey: string): void;
}

export abstract class IStorageService {
   public abstract set(key: string, value: any);
   public abstract get(key: string): any;
   public abstract remove(key: string);
   public abstract setSession(key: string, value: any);
   public abstract getSession(key: string): string;
   public abstract removeSession(key: string);
   public abstract clearSession();
}
